/*
  What a region means when you tick it.

  **The owner's decision of 7 September 2026**, answering a question raised on 3
  September while drawing Group D: giving somebody their locations meant ticking
  forty rows out of 314, one at a time, with no search. He asked for a region to
  be the quick way and for exceptions on top of it.

  So: tick Dallas and every Dallas location ticks in front of you. Untick it and
  they untick. Anything you change by hand afterwards is an exception, and it
  survives, because what gets saved is the list on the screen and nothing else.

  This lives here rather than inside the screen because it is the part that is
  easy to get wrong and impossible to see going wrong: unticking a region must
  take away only its own locations, and ticking one must not disturb an
  exception somebody made in a different region.

  **The other half of "a region" is not here and cannot be.** A location that
  opens in Dallas next month has to reach whoever covers Dallas, and no browser
  is watching when that happens. The database does it, in
  `spread_new_location_to_its_region`.
*/
export function regionsChanged({ regions, warehouses }, next, locations) {
  const added   = next.filter(r => !regions.includes(r));
  const removed = regions.filter(r => !next.includes(r));

  const inAdded   = locations.filter(w => added.includes(w.regionId)).map(w => w.id);
  const inRemoved = locations.filter(w => removed.includes(w.regionId)).map(w => w.id);

  return {
    regions: next,
    warehouses: [...new Set([...warehouses, ...inAdded])].filter(id => !inRemoved.includes(id)),
  };
}
